<script lang="ts">
  // components
  import PopoverWithButton from "@shared/svelte/Components/Popover/PopoverWithButton.svelte";

  // services
  import { capitalize } from "lodash";

  // types
  import type { PopoverAlignmentOptions } from "@shared/types/PopoverWithButton";

  // props
  export let options: any[];
  export let minWidth: string = null;
  export let selectedValues: any[];
  export let defaultButtonLabel: string;
  export let object: string;
  export let searchValue: string;
  export let useSearch: boolean = true;
  export let onDistributorSearch: (event: object) => void;
  export let onCheckboxChange: (event: object) => void;
  export let onClear: (event: object) => void;
  export let position: string = "";
  export let alignmentOptions: PopoverAlignmentOptions;
  export let spacing = "";
  export let showSelectAll: boolean = false;

  // values
  let showPopover: boolean = false;

  // functions
  const openPopover = () => {
    showPopover = !showPopover;
    showSelector();
  };
  const showSelector = () => {
    if (!showPopover) return;
  };
  const labelForButton = values => {
    const objectLength = values?.length;
    if (objectLength == 0 && objectLength != undefined) {
      return defaultButtonLabel;
    } else {
      return `${capitalize(object)}${objectLength > 1 ? "s" : ""} Selected (${objectLength})`;
    }
  };

  function handleSelectAllChange(event: Event) {
    const checkbox = event.target as HTMLInputElement;
    const shouldCheckAll = checkbox.checked;

    for (const option of formattedOptions) {
      if (option.checked !== shouldCheckAll) {
        const syntheticEvent = {
          target: {
            value: option.id || option.value,
            checked: shouldCheckAll,
          },
        };
        onCheckboxChange(syntheticEvent);
      }
    }
  }

  // reactives
  $: showSelector;
  $: formattedOptions = options.map(option => ({
    ...option,
    checked: option.checked || selectedValues.includes(option.id),
  }));
  $: allSelected = showSelectAll
    ? formattedOptions.length > 0 && formattedOptions.every(o => o.checked)
    : false;
</script>

<style>
  hr {
    border: 0.5px solid #eaeaea;
    background-color: #eaeaea;
    color: #eaeaea;
    margin-left: -1rem;
    margin-right: -1rem;
  }
  .popover-container {
    border-radius: 0.25rem;
  }
</style>

<div>
  <PopoverWithButton
    bind:show={showPopover}
    buttonLabel={labelForButton(selectedValues)}
    {openPopover}
    {position}
    icon={{ type: "ArrowDown", width: "12", height: "12" }}
    selectButtonStyle={false}
    arrow={false}
    customButtonStyle={"width: 100%"}
    objectName={object}
    {alignmentOptions}
  >
    <div
      class="fizz-surface fizz-inset-square-16 popover-container"
      style="min-width: {minWidth}; max-height: 600px; overflow: scroll"
    >
      {#if useSearch}
        <div class="fizz-flex-row-responsive fizz-stack-16">
          <input
            type="text"
            name="search"
            id="${object}-search-input"
            class="fizz-input-search fizz-full-width"
            bind:value={searchValue}
            on:keyup={onDistributorSearch}
          />
        </div>
      {/if}
      {#if showSelectAll}
        <div class="fizz-stack-16">
          <label class="fizz-flex-row-24" for="selectAll">
            <input
              class="fizz-checkbox"
              type="checkbox"
              id="selectAll"
              on:change={handleSelectAllChange}
              bind:checked={allSelected}
            />
            <span class="fizz-text-small">Select All</span>
          </label>
        </div>
      {/if}
      <div class={`fizz-stack-16 ${spacing}`}>
        {#each formattedOptions as option}
          <label class="fizz-flex-row-24" for={option.id || option.value}>
            <input
              class="fizz-checkbox"
              type="checkbox"
              name="checkbox"
              id={option.id || option.value}
              value={option.id || option.value}
              on:click={onCheckboxChange}
              bind:checked={option.checked}
            />
            <span class="fizz-text-small">{option.name || option.label}</span>
          </label>
        {/each}
      </div>
      <hr class="fizz-stack-8" />
      <div class="fizz-flex-row-responsive">
        <button class="fizz-button-text fizz-button-small" on:click={onClear}> Clear </button>
      </div>
    </div>
  </PopoverWithButton>
</div>
